exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".src-components-companyDetails-CompanyUsers-button{min-width:100%}.src-components-companyDetails-CompanyUsers-link{color:#fff}.src-components-companyDetails-CompanyUsers-link:hover{color:#fff}", ""]);

// exports
exports.locals = {
	"button": "src-components-companyDetails-CompanyUsers-button",
	"link": "src-components-companyDetails-CompanyUsers-link"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"modules":true,"localIdentName":"[path][local]"}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./node_modules/sass-loader/dist/cjs.js!./src/components/companyDetails/CompanyUsers/styles.scss
// module id = ./node_modules/css-loader/index.js?{"importLoaders":1,"modules":true,"localIdentName":"[path][local]"}!./node_modules/postcss-loader/lib/index.js?{"ident":"postcss","plugins":[null,null]}!./node_modules/sass-loader/dist/cjs.js!./src/components/companyDetails/CompanyUsers/styles.scss
// module chunks = 1